import { useSelector } from 'react-redux'
import { usePagination } from '../../../hooks/use-pagination'
import { RootState } from '../../../store/modules/rootReducer'
import { useEffect, useState } from 'react'
import { useDebouncedState } from '../../../hooks/use-debounced-state'
import useSWR, { SWRConfiguration } from 'swr'
import { toast } from 'react-toastify'
import { coreApi } from '../../../services/api'
import { TMessageResponse } from '../components/MessagesList/types'

const PAGE_SIZE = 4

const fetcher = (url: string[]) => coreApi.get(url.join('')).then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: { docs: [], total: 0 },
  onError() {
    toast.error('Não foi possível carregar seus recados. Tente novamente mais tarde.')
  },
  errorRetryCount: 0,
}

export const useGetMessages = () => {
  const studentId = useSelector((state: RootState) => state.student.profile._id)

  const [totalPages, setTotalPages] = useState(1)
  const [notReadState, setNotReadState] = useState(false)
  const [searchState, setSearchState] = useDebouncedState('', 1000)

  const pagination = usePagination({ total: totalPages, initialPage: 1 })

  const searchParams = new URLSearchParams(`?page=${pagination.active}&limit=${PAGE_SIZE}`)

  if (notReadState) searchParams.append('read', 'false')
  if (searchState) searchParams.append('search', searchState)

  const search = '?' + searchParams.toString()

  const key = studentId ? [`/notifications/messages/student/${studentId}`, search] : null

  const swr = useSWR<TMessageResponse>(key, fetcher, configuration)

  const isLoading = swr.isLoading || swr.error || !studentId

  const setSearch = (value: string) => {
    const removeSpecialCharacterRegex = /[^\p{L}\p{N}\s]/gu

    setSearchState(value.replace(removeSpecialCharacterRegex, ''))
    pagination.first()
  }

  const setNotRead = (value: boolean) => {
    setNotReadState(value)
    pagination.first()
  }

  useEffect(() => {
    setTotalPages(Math.ceil((swr.data.total || 1) / PAGE_SIZE))
  }, [swr.data.total])

  return {
    swr,
    isLoading,
    pagination,
    params: { setSearch, setNotRead },
  }
}

export type TUseGetMessagesReturn = ReturnType<typeof useGetMessages>
